<template>
    <RightSideBar
        @submit="editMode ? updateScale() : addNewScale()"
        @close="$emit('close')" submit="Save" :loading="loadingData"
        button-class="bg-dynamicBackBtn text-white"
    >
        <template v-slot:title>
            <p class="text-darkPurple">
            {{ editMode ? `Edit Scale ` : `Add New Scale `}}
            </p>
        </template>
        <div class="grid grid-cols-12 gap-8 text-darkPurple"
            style="margin-top: 1.5rem"
        >
            <div class="col-span-12">
              <c-text
                label="Scale Name"
                placeholder="--Enter--"
                variant="w-full h-10"
                style="height: 40px !important"
                v-model="groupPayload.name"
                :rules="['required']"
              />
            </div>

            <div class="col-span-12 mt-3">
              <div class="text-sm flex gap-2">
                <p class="text-base w-auto">
                  Description
                </p>
              </div>
              <c-textarea v-model="groupPayload.description" :rules="['required']" />
            </div>
        </div>
    </RightSideBar>
</template>

<script>
import CText from "@scelloo/cloudenly-ui/src/components/text";
import CTextarea from "@scelloo/cloudenly-ui/src/components/text-area";
import RightSideBar from "@/components/RightSideBar";

export default {
  components: {
    CText,
    CTextarea,
    RightSideBar,
  },
  props: {
        scaleGroupData: {
            type: Object,
            default: () => {}
        },
        editMode: {
            type: Boolean,
            default: false
        },
        groupId: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            loadingData: true,
            groupPayload: {
                name: "",
                description: ""
            },
        }
    },
    async mounted() {
        this.groupPayload = this.editMode ? this.scaleGroupData : this.groupPayload;
        this.loadingData = false;
    },
    methods:{
        async updateScale(){
            try {
                await this.$_updateScaleGroup(this.groupPayload, this.groupId);
                this.loadingData = false;
                this.$emit('close');
                this.$emit('reload');
                return this.$toasted.success("Scale group updated successfully.", {duration: 6000});
            } catch (error) {
                this.loadingData = false;
                this.$toasted.error('Error updating scale group.', {duration: 3000})
            }
        },
        async addNewScale(){
            try {
                await this.$_createScaleGroup(this.groupPayload);
                this.loadingData = false;
                this.$emit('close');
                this.$emit('reload');
                return this.$toasted.success("Scale gruop successfully added.", {duration: 6000});
            } catch (error) {
                this.loadingData = false;
                this.$toasted.error('Error adding scale group.', {duration: 3000})
            }
        },
    }
};
</script>
